import styled from 'styled-components';

export const TermsTextContainer = styled.div`
  margin-left: 15px;

  :last-of-type {
    margin-bottom: 0;
  }
`;

export const TermsText = styled.span`
  font-size: 14px;
`;

export const TermsLink = styled.a`
  font-size: 14px;
  font-weight: bold;
  text-decoration: underline;
`;

export const TermsButton = styled.button`
  font-size: 14px;
  font-weight: bold;
  text-decoration: underline;
`;
